export const ClockIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.99996 0.041687C4.05241 0.041687 0.041626 4.05247 0.041626 9.00002C0.041626 13.9476 4.05241 17.9584 8.99996 17.9584C13.9475 17.9584 17.9583 13.9476 17.9583 9.00002C17.9583 4.05247 13.9475 0.041687 8.99996 0.041687ZM12.1608 4.66073L9.00004 7.82144L7.08927 5.91073L5.91077 7.08924L7.82154 9.00002L7.16077 9.66069L8.33929 10.8393L9.00004 10.1785L9.66079 10.8393L10.8393 9.66069L10.1785 9.00002L13.3393 5.83924L12.1608 4.66073Z"
      fill="currentColor"
    />
  </svg>
);
